import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
  APP_TITLE: string = 'IoT BASED DIGITAL PROJECT TRACKING SYSTEMS';
}
